import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const tipoServicoReducer = (state = InitialState.tipoServicoReducer, action) => {
    switch (action.type) {
        case ActionType.GET_TIPO_SERVICO_RESPONSE: {
            return {
                ...state,
                tipoServicoObject: _.assign(action.tipoServicoObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default tipoServicoReducer;